<template>
   <iframe :src="url" frameborder="0" width="100%" height="100%"></iframe>
</template>

<script>
export default {
  name:"FramePage",
  data() {
    return {
      url: '',
    };
  },
  created() {
    this.url = this.$route.query.url || '';
  },
}
</script>